const links = {
  registry: "https://www.target.com/gift-registry/gift-giver?registryId=b05bb8d0-c993-11ed-938e-e785c7ebbce2&type=WEDDING",
  reform: "https://reformcollective.com",
  sleepyRidge: "https://www.google.com/maps/place/Sleepy+Ridge+Weddings/@40.2838485,-111.7468386,17z/data=!3m2!4b1!5s0x874d9b4164e46863:0xc532e0268d2dc9da!4m6!3m5!1s0x874d9b442177b195:0xdfc7f8af9c7ccedb!8m2!3d40.2838444!4d-111.7442583!16s%2Fg%2F1vf9cvmp"
} as const

export default links
